var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.361,
    height: 16.34,
    viewBox: "0 0 9.361 16.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7a2581;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.34) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a2581"
    },
    className: "a",
    d: "M316.292,402.719l-7.105,6.96c-.006.006-.013.01-.018.014a1,1,0,0,1-.116.092c-.021.015-.04.031-.062.044a1.055,1.055,0,0,1-.117.058c-.026.011-.052.024-.078.033a.934.934,0,0,1-.111.028c-.031.006-.062.014-.093.018a2.231,2.231,0,0,1-.206,0,.917.917,0,0,1-.092-.018.87.87,0,0,1-.111-.028c-.026-.009-.052-.022-.078-.033a.939.939,0,0,1-.116-.058c-.021-.013-.042-.029-.063-.044a.936.936,0,0,1-.115-.092.189.189,0,0,1-.018-.014l-7.106-6.959a1.315,1.315,0,0,1-.107-1.7,1.013,1.013,0,0,1,.806-.415.994.994,0,0,1,.7.294l6.406,6.274L314.9,400.9a.993.993,0,0,1,.7-.294,1.012,1.012,0,0,1,.806.415A1.313,1.313,0,0,1,316.292,402.719Z",
    transform: "translate(-300.32 -400.607)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.5f29ec7e.svg";
export { ForwardRef as ReactComponent };